<template>
  <div class="wg-reservations">
    <div class="themesflat-container">
      <div class="row">
        <div class="col-md-6 align-items-center" style="padding: 60px">
          <div class="content">
            <div class="heading-section text-center">
              <div class="sub">{{ $t("franchise") }}</div>
              <div class="main" :lang="langStore.lang === 'gr' ? 'el' : 'en'">{{ franchise.franchise_title }}</div>
              <div class="text">{{ franchise.franchise_description }}</div>
              <div class="divider"><div></div></div>
            </div>
            <FranchiseFormComponent />
          </div>
        </div>

        <div class="col-md-6">
          <div class="image">
            <img :src="getImageUrl(franchise.franchise_image)" alt="" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { langStore } from "../../langStore";
import FranchiseFormComponent from "./FranchiseFormComponent.vue";

export default {
  name: "NewFranchiseComponent",
  components: {
    FranchiseFormComponent,
  },

  data() {
    return {
      langStore,
      franchise: {},
    };
  },

  watch: {
    "langStore.lang"() {
      this.fetchFranchise();
    },
  },

  mounted() {
    this.fetchFranchise();
  },

  methods: {
    async fetchFranchise() {
      try {
        const response = await axios.get(
          `${process.env.VUE_APP_BASE_URL}/api/franchise`,
          { params: { lang: this.langStore.lang } }
        );

        this.franchise = response.data;

        // WAIT FOR IMAGES TO LOAD
        this.waitForImages();
      } catch (error) {
        console.error("There was an error fetching the data:", error);
        this.$emitContentReady(); // still hide preload
      }
    },

    getImageUrl(photo) {
      return `${process.env.VUE_APP_BASE_URL}/uploads/website/` + photo;
    },
  },
};
</script>

<style scoped>
.error-message {
  color: #ff3b3b;
  margin-bottom: 10px;
  font-size: 16px;
  font-weight: 900;
}

.success-message {
  color: #2ecc71;
  margin-bottom: 10px;
  font-size: 16px;
  font-weight: 900;
}

.image {
  width: 100%;
  height: 100%; /* or a fixed height if needed */
  overflow: hidden;
}

.image img {
  width: 100%;
  height: 100%;
  object-fit: cover; /* fills container, crops excess, no stretching */
  display: block;
}
</style>
